import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import HeadTitle from 'components/HeadTitle';
import Tabs from 'components/Tabs';

import { getTagList } from 'utils/helpers/landings';

import styles from './styles.module.scss';

const Search = ({
	title,
	subtitle,
	images,
	tags,
	className,
	backgroundImage,
	backgroundImageClassName,
	mainImage,
	imageClassName,
	backgroundMobileSize
}) => {
	const list = getTagList(tags, 'read');

	return (
		<div
			className={cx(styles.block, className, styles[`images_${images.length}`])}
			style={{
				backgroundImage: backgroundImage ? `url(${backgroundImage})` : null
			}}
		>
			<div
				className={cx(
					styles.background,
					styles[`background_${mainImage}`],
					styles[`background_${backgroundMobileSize}`],
					backgroundImageClassName
				)}
			>
				{images.map((image) => (
					<div key={image} className={cx(styles.imageWrapper, imageClassName)}>
						<img className={styles.image} src={image} alt="" />
					</div>
				))}
			</div>
			<div className={cx(styles.body, 'pvi-no-styles')}>
				<HeadTitle className={styles.title} text={title} size="large" />
				{subtitle && <div className={styles.subtitle}>{subtitle}</div>}
				<form className={styles.search} action="/search">
					<Icon className={styles.searchIcon} icon="search" />
					<input
						className={styles.input}
						type="text"
						name="query"
						placeholder="Начните вводить название"
					/>
					<button type="submit" className={styles.button}>
						<span className={styles.buttonTitle}>Найти</span>
						<Icon className={styles.buttonIcon} icon="search" />
					</button>
				</form>
				<Tabs
					className={styles.tabs}
					list={list}
					theme="gray"
					sliderParams={{
						slidesOffsetAfter: 8,
						breakpoints: {},
						/* eslint-disable react/no-this-in-sfc, object-shorthand */
						slidesOffsetBefore: function () {
							if (!_.isEmpty(this?.slides)) {
								const lastSlide = _.last(this.slides);
								const wrapperWidth =
									lastSlide?.offsetLeft +
									lastSlide?.offsetWidth -
									this.slides[0]?.offsetLeft;

								if (window.innerWidth > wrapperWidth) {
									return (window.innerWidth - wrapperWidth) / 2;
								}
							}

							return 8;
						}
						/* eslint-enable react/no-this-in-sfc, object-shorthand */
					}}
				/>
			</div>
		</div>
	);
};

Search.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	images: PropTypes.arrayOf(PropTypes.string),
	tags: PropTypes.array,
	className: PropTypes.string,
	backgroundImageClassName: PropTypes.string,
	backgroundImage: PropTypes.string,
	mainImage: PropTypes.oneOf(['left', 'right']),
	backgroundMobileSize: PropTypes.oneOf(['small']),
	imageClassName: PropTypes.string
};

Search.defaultProps = {
	images: [],
	tags: [],
	mainImage: 'left'
};

export default Search;
